































import BaseVue from "../../core/BaseVue";
import User from "../../models/security/user.model";
import UserService from "@/services/user.service";
import GenericBTable from "../../core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import Base from "../../models/base/Base.model";
import PorposalComponent from "@/components/myPorposalsTable/myPorposalTable.vue";
import { Component } from "vue-property-decorator";
import Vue from "vue";
import { ProposalState } from "@/enums/ProposalState";
import PorposalService from "../../services/porposal.service";
import Porposal from "../../models/porposal/porposal.model";
@Component({
  components: {
    PorposalComponent
  }
})
export default class PorposalHistory extends Vue {
  userRequested: User | null = null;
  userService: UserService = new UserService();
  proposalService: PorposalService = new PorposalService();
  model: any;
  stateHide = false;
  enviado: ProposalState = ProposalState.EnviadoCI;
  devuelto: ProposalState = ProposalState.DevueltoCI;
  creado: ProposalState = ProposalState.Creado;
  rechazado: ProposalState = ProposalState.RechazadoCI;
  enviadoFondcyt: ProposalState = ProposalState.EnviadoFC;

  proposals = [];

  constructor() {
    super();
    this.model = new User();
  }
  created() {}
}
